export const profileSettingsReducerKey = 'profileSettingsReducerKey';
export const profileSettingsSetIsLoadingReducerType = 'profileSettingsSetIsLoadingReducerType';
export const PROFILE_SETTINGS_TABS_ID = 'profile-settings-tabs';

export const ProfileSettingsTabPanels = {
  ACCOUNT: {
    panelId: 'profile-settings-account-panel',
    tabId: `tab-${PROFILE_SETTINGS_TABS_ID}-0`,
  },
  PROFILE: {
    panelId: 'profile-settings-profile-panel',
    tabId: `tab-${PROFILE_SETTINGS_TABS_ID}-1`,
  },
  PREFERENCES: {
    panelId: 'profile-settings-preferences-panel',
    tabId: `tab-${PROFILE_SETTINGS_TABS_ID}-2`,
  },
};

export const PreferencesSectionsMapping = {
  RESULT_PER_PAGE: ['RESULT_PER_PAGE.RX2_PAGE_SIZE'],
  PROFILE: [
    'PROFILE.salutation',
    'PROFILE.firstName',
    'PROFILE.lastName',
    'PROFILE.jobTitle',
    'PROFILE.email',
    'PROFILE.photoUrl',
    'PROFILE.username',
  ],
  PREFERRED_SUPPLIERS: [
    'SUPPLIERS.RX2_SUPPLIERS',
    'CURRENCIES.RX2_CURRENCIES',
    'SHIPMENT_COUNTRIES.RX2_SHIPMENT_COUNTRY',
    'SHIPPING_TIMES.RX2_SHIPPING_TIME',
  ],
  DEFAULT_EDITOR_SETTINGS_SEARCH_DRAWING: ['DEFAULT_EDITOR_SETTINGS.RX2_SEARCH_BY'],
  DEFAULT_STRUCTURE_EDITOR: ['DEFAULT_EDITOR_SETTINGS.RX2_STRUCTURE_EDITOR_PRESELECTED'],
  DEFAULT_EDITOR_SETTINGS_PREFERENCES: [
    'DEFAULT_EDITOR_SETTINGS.RX2_OPTIONS.RX2_ISOTOPES',
    'DEFAULT_EDITOR_SETTINGS.RX2_OPTIONS.RX2_STEREO',
    'DEFAULT_EDITOR_SETTINGS.RX2_OPTIONS.RX2_TAUTOMERS',
    'DEFAULT_EDITOR_SETTINGS.RX2_OPTIONS.RX2_KEEP_FRAGMENTS',
    'DEFAULT_EDITOR_SETTINGS.RX2_OPTIONS.RX2_MIXTURES',
    'DEFAULT_EDITOR_SETTINGS.RX2_OPTIONS.RX2_MARKUSH',
    'DEFAULT_EDITOR_SETTINGS.RX2_OPTIONS.RX2_RADICALS',
    'DEFAULT_EDITOR_SETTINGS.RX2_OPTIONS.RX2_EXTRA_RINGS',
    'DEFAULT_EDITOR_SETTINGS.RX2_OPTIONS.RX2_CHARGES',
    'DEFAULT_EDITOR_SETTINGS.RX2_OPTIONS.RX2_SALTS',
    'DEFAULT_EDITOR_SETTINGS.RX2_OPTIONS.RX2_IGNORE_ATOM_MAPPING',
    'DEFAULT_EDITOR_SETTINGS.RX2_ATOMS_NUMBER',
    'DEFAULT_EDITOR_SETTINGS.RX2_RING_CLOSURES_NUMBER',
    'DEFAULT_EDITOR_SETTINGS.RX2_FRAGMENTS_NUMBER',
  ],
  AUTOPLAN: [
    'AUTOPLAN.RX2_AUTOPLAN_FULL_ROUTES',
    'AUTOPLAN.RX2_AUTOPLAN_MAX_BEST_PATHS',
    'AUTOPLAN.RX2_AUTOPLAN_MAX_ALTERNATIVE_BRANCHES',
    'AUTOPLAN.RX2_AUTOPLAN_MAX_DEPTH',
    'AUTOPLAN.RX2_AUTOPLAN_STOP_WHEN_COMMERCIALLY_AVAILABLE',
    'AUTOPLAN.RX2_AUTOPLAN_DEFAULT_YIELD',
  ],
  PREDICTION_PLAN: [
    'PREDICTION_PLAN.RX2_PREDICTION_PLAN_SHOW_FULL_STEPS',
    'PREDICTION_PLAN.RX2_PREDICTION_PLAN_DEPTH',
    'PREDICTION_PLAN.RX2_PREDICTION_PLAN_STEPS',
    'PREDICTION_PLAN.RX2_PREDICTION_PLAN_BLOCKS',
    'PREDICTION_PLAN.RX2_PREDICTION_PLAN_PROCESSING_TIME',
  ],
  PREDICTION_PLAN_IKTOS: [
    'PREDICTION_PLAN_IKTOS.RX2_PREDICTION_PLAN_IKTOS_MAXSTEPS',
    'PREDICTION_PLAN_IKTOS.RX2_PREDICTION_PLAN_IKTOS_STEREO',
    'PREDICTION_PLAN_IKTOS.RX2_PREDICTION_PLAN_IKTOS_REGIO',
    'PREDICTION_PLAN_IKTOS.RX2_PREDICTION_PLAN_IKTOS_PRICE',
    'PREDICTION_PLAN_IKTOS.RX2_PREDICTION_PLAN_LIBRARIES',
    'PREDICTION_PLAN_IKTOS.RX2_PREDICTION_PLAN_IKTOS_PROCESSING_TIME',
  ],
  SHOW_AUTOPLAN: ['AUTOPLAN.RX2_SHOW_AUTOPLAN_PREF'],
  RX2_SYNTHESIS_CONDITIONS_POSITION: [
    'SYNTHESIS_PLANNER.RX2_SYNTHESIS_CONDITIONS_POSITION',
    'SYNTHESIS_PLANNER.RX2_SYNTHESIS_CONDITIONS_ALWAYS_SHOW',
  ],
};

export const PROFILE_ERRORS_LIST = [22];
